import { render } from "./FieldLink.vue?vue&type=template&id=39177f3b&scoped=true"
import script from "./FieldLink.vue?vue&type=script&lang=js"
export * from "./FieldLink.vue?vue&type=script&lang=js"

import "./FieldLink.vue?vue&type=style&index=0&id=39177f3b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39177f3b"]])

export default __exports__